const MetaFactsFileIcon = ({ width = "12", height = "12" }) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 9 12"
    fill="none"
  >
    <path
      d="M0 1.5C0 0.672656 0.672656 0 1.5 0H5.25V3C5.25 3.41484 5.58516 3.75 6 3.75H9V10.5C9 11.3273 8.32734 12 7.5 12H1.5C0.672656 12 0 11.3273 0 10.5V1.5ZM9 3H6V0L9 3Z"
      fill="#3F83F8"
    />
  </svg>
);
export default MetaFactsFileIcon;
